import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en } from './locales/en'
import { he } from './locales/he'
import { ar } from './locales/ar'
import { ru } from './locales/ru'
import { readStoredSettings } from '../store/settingsStore'

const initialLanguage = readStoredSettings().language.toLowerCase()

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    he: { translation: he },
    ar: { translation: ar },
    ru: { translation: ru },
  },
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
